import { CaretDown, CaretUp } from '@phosphor-icons/react';
import { ReactNode } from 'react';
import { SVG_SIZE_S } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { ToggleProps } from 'src/v2/commonComponents/DrawerTooltipContainer';

interface PackOptionsToggleProps extends ToggleProps {
  title?: ReactNode;
}

export const PackOptionsToggle = ({
  id,
  onClick,
  title,
  isActive,
}: PackOptionsToggleProps) => {
  return (
    <Button id={id} color="secondary-outline" onClick={onClick} fullWidth>
      {title}

      {isActive ? (
        <CaretUp size={SVG_SIZE_S} />
      ) : (
        <CaretDown size={SVG_SIZE_S} />
      )}
    </Button>
  );
};
